export default __webpack_public_path__ + "static/media/franco-leutewiler-henriques.55c5cc95.png";